import { mergeStyleSets } from "@fluentui/merge-styles";
import { useMemo } from "react";

const classNames = {
  root: `FilterRoot`
};

export function useFilterStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [classNames.root, {}]
    }),
    []
  );
}
